/* __next_internal_client_entry_do_not_use__ LoadingSpinner,rotate,dash,SVG,Circle auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import * as React from "react";
import styled, { keyframes } from "styled-components";
import { highVisSlateComponent, HIGH_VIS_FILTER } from "../utils/highVisSlateComponent";
var SpinnerSizes = {
    small: 16,
    medium: 24,
    large: 48
};
/**
 * @trackcomponent
 */ export var LoadingSpinner = function(param) {
    var _param_color = param.color, color = _param_color === void 0 ? Core.icon.default : _param_color, _param_size = param.size, size = _param_size === void 0 ? "large" : _param_size, className = param.className, dataTestId = param["data-test-id"];
    var strictLocalize = useStrictLocalization().strictLocalize;
    var spinnerSize = SpinnerSizes[size];
    return /*#__PURE__*/ _jsx(SVG, {
        role: "status",
        "aria-label": strictLocalize({
            id: "LJ8sQp",
            defaultMessage: [
                {
                    type: 0,
                    value: "Loading"
                }
            ]
        }),
        viewBox: "25 25 50 50",
        width: spinnerSize,
        height: spinnerSize,
        className: className,
        "data-test-id": dataTestId,
        children: /*#__PURE__*/ _jsx(Circle, {
            cx: "50",
            cy: "50",
            r: "20",
            stroke: color,
            fill: "none",
            strokeWidth: 2,
            strokeMiterlimit: "10"
        })
    });
};
export var rotate = keyframes([
    "100%{transform:rotate(360deg);}"
]);
export var dash = keyframes([
    "0%{stroke-dasharray:1,200;stroke-dashoffset:0;}50%{stroke-dasharray:89,200;stroke-dashoffset:-35px;}100%{stroke-dasharray:89,200;stroke-dashoffset:-124px;}"
]);
export var SVG = styled.svg.withConfig({
    componentId: "sc-19374826-0"
})([
    "animation:",
    " 2s linear infinite;transform-origin:center center;",
    ""
], rotate, highVisSlateComponent(HIGH_VIS_FILTER.COMPONENT));
export var Circle = styled.circle.withConfig({
    componentId: "sc-19374826-1"
})([
    "stroke-dasharray:1,200;stroke-dashoffset:0;animation:",
    " 1.5s ease-in-out infinite;stroke-linecap:round;"
], dash);
